// Days Sales Outstanding — average number of days it takes to collect on a
// sale. Computed as outstanding receivables divided by the average daily net
// sales so far this year (YTD net sales / days elapsed). Returns null when the
// denominator is undefined (no sales recorded yet, or no days elapsed) so the
// caller can fall back to a plain subtitle.
export function computeDso(
  outstanding: number,
  ytdNetSales: number,
  daysElapsed: number,
): number | null {
  if (ytdNetSales <= 0 || daysElapsed <= 0) return null;
  return Math.round(outstanding / (ytdNetSales / daysElapsed));
}
